// Keep replay watching independent from lobby auth, live sockets and match writes.
if (/^\/replay\/[1-9]\d*\/?$/.test(location.pathname) ||
    new URLSearchParams(location.search).has('replay') ||
    new URLSearchParams(location.search).has('tournament_watch')) {
  import('./replay/replayEntry.js');
} else {
  import('./main.js');
}
